import React, { useContext, useEffect, useState } from "react";
import { languages } from "../Vocabulary/Vocabulary";
import axios from "axios";
import { categories as cats, items as i } from "./utils/data";
import picture0 from "../AdminPanel/picture/0.png";
import picture1 from "../AdminPanel/picture/1.png";
//import picture2 from "../AdminPanel/picture/2.png";
import picture2 from "../AdminPanel/picture/docs.png";
//import picture3 from "../AdminPanel/picture/3.png";
import picture3 from "../AdminPanel/picture/mail-phone.png";
import picture4 from "../AdminPanel/picture/4.png";
import picture5 from "../AdminPanel/picture/5.png";
import picture6 from "../AdminPanel/picture/6.png";
import picture7 from "../AdminPanel/picture/7.png";
import picture8 from "../AdminPanel/picture/8.png";
import picture9 from "../AdminPanel/picture/9.png";
import picture10 from "../AdminPanel/picture/10.png";
import picture11 from "../AdminPanel/picture/11.png";
import dictionaryLanguage from "../Vocabulary/dictionaryLanguage";

const AppContext = React.createContext();

const empty = {
  id: "-1",
  name: ""
};

const emptyPretraga = {
  radnoMesto: empty,
  istekDokumenta: empty,
  poslovnaJedinica: empty,
  pretraga: ""
};

const AppProvider = ({ children }) => {
  // const [selectedLanguage, setSelectedLanguage] = useState(
  //   JSON.parse(localStorage.getItem("select-language")) || undefined
  // );
  const [selectedLanguage, setSelectedLanguage] = useState("latinica");
  const dictionary = dictionaryLanguage[selectedLanguage];

  const [slideButton, setSlideButton] = useState([
    { name: "KEY", picture: picture10, active: 0 },
    { name: "MESSAGES", picture: picture1, active: 0 },
    { name: "SPEAKER", picture: picture0, active: 0 },
    { name: "HEADPHONES", picture: picture2, active: 0 },
    { name: "MAIL", picture: picture3, active: 0 },
    { name: "FOLDER", picture: picture6, active: 0 },
    // { name: "PICTURE", picture: picture5, active: 0 },
    { name: "NOTEBOOK", picture: picture9, active: 0 },
    { name: "LANGUAGE", picture: picture8, active: 0 },
    { name: "CALENDAR", picture: picture7, active: 0 },
    { name: "NOTIFICATION", picture: picture11, active: 0 }
  ]);
  // const [slideButton, setSlideButton] = useState([
  //   { name: "KEY", picture: picture10, active: 0 },
  //   { name: "MESSAGES", picture: picture1, active: 0 },
  //   { name: "SPEAKER", picture: picture0, active: 0 },
  //   { name: "HEADPHONES", picture: picture2, active: 0 },
  //   { name: "MAIL", picture: picture3, active: 0 },
  //   { name: "FOLDER", picture: picture6, active: 0 },
  //   { name: "PICTURE", picture: picture5, active: 0 },
  //   { name: "NOTEBOOK", picture: picture9, active: 0 },
  //   { name: "LANGUAGE", picture: picture8, active: 0 },
  //   { name: "CALENDAR", picture: picture7, active: 0 },
  //   { name: "NOTIFICATION", picture: picture11, active: 0 },
  // ]);

  const [account, setAccount] = useState();
  const [loggedUser, setLoggedUser] = useState(
    JSON.parse(localStorage.getItem("editor-user")) || undefined
  );
  const [typeButton, setTypeButton] = useState(
    loggedUser === undefined ? 0 : loggedUser.typeButton
  );
  const [colorButton, setColorButton] = useState(
    loggedUser === undefined ? "#CCC" : loggedUser.colorButton
  );
  const [letterSize, setLetterSize] = useState();
  const [boldItalic, setBoldItalic] = useState([]);
  const [controlEmail, setControlEmail] = useState(undefined);
  const [baseUrl] = useState("https://data.nadzor.app/api");
  const [documentsUrl] = useState("https://data.nadzor.app/api/items/files/");
  const [imagesUrl] = useState("https://data.nadzor.app/api/items/uploads/");
  const [adminDocsUrl] = useState(
    "https://data.nadzor.app/api/location_documents/files/"
  );
  const [galleryUrl] = useState(
    "https://data.nadzor.app/api/admin_panel/gallery/uploads/"
  );
  const [apiKey, setApiKey] = useState(
    JSON.parse(localStorage.getItem("api-key")) || ""
  );
  const [currentChat, setCurrentChat] = useState(null);
  const [entryKey, setEntryKey] = useState("");
  const [location, setLocation] = useState();
  const [activeIconsMiddle, setActiveIconsMiddle] = useState([]);
  const [openAddLink, setOpenAddLink] = useState(false);
  const [newLinks, setNewLinks] = useState([]);
  const [copy, setCopy] = useState({ index: null, value: false });
  const [isAndroid, setIsAndroid] = useState(false);
  const [isIOS, setIsIOS] = useState(false);
  const [userReload, setUserReload] = useState(false);
  const [fontSize, setFontSize] = useState();
  const [fontStyle, setFontStyle] = useState();
  const [isFromHome, setIsFromHome] = useState(false);
  const [isFromFirstTrustContact, setIsFromFirstTrustContact] = useState(false);
  const [fromEnterCode, setFromEnterCode] = useState(false);


  const [isLZOClicked, setIsLZOClicked] = useState(false);

  //admin-panel state
  const [currentChatAdmin, setCurrentChatAdmin] = useState(null);
  const [activeIconsMiddleAdmin, setActiveIconsMiddleAdmin] = useState([]);
  const [activeIcons, setActiveIcons] = useState([]);
  const [activeClass, setActiveClass] = useState("");
  const [idleClass, setIdleClass] = useState("");
  const [activeStates, setActiveStates] = useState([]);
  const [cancelIndex, setCancelIndex] = useState(null);
  const [currentName, setCurrentName] = useState("");
  const [viewDocument, setViewDocument] = useState({
    index: 0,
    value: false
  });
  const [openPicture, setOpenPicture] = useState({
    index: 0,
    value: false
  });
  const [chooseObject, setChooseObject] = useState(null);
  const [chooseObjectPreview, setChooseObjectPrivew] = useState(null);
  const [selectedSettings, setSelectedSettings] = useState(0);

  // "", "PROCENA_RIZIKA", "EVIDENCIJE_OBRASCI", "POSLOVNE_JEDINICE", "SREDSTVA_OPREMA", "DOKUMENTA_ZAPOSLENIH",
  // "ZASTITA_OD_POZARA", "ZASTITA_ZIVOTNE_SREDINE", "POSLOVNI_SARADNICI", "UGOVORI_ODLUKE"
  const [selectedNavbarDocument, setSelectedNavbarDocument] = useState("");
  // 0 (nista nije selektovano),1,2,3...11
  const [selectedEvidencija, setSelectedEvidencija] = useState(0);
  // 0 (nista nije selektovano),1, 2, 3...
  const [selectedProcenaRizika, setSelectedProcenaRizika] = useState(0);
  // id poslovne jedinice
  const [selectedPoslovnaJedinica, setSelectedPoslovnaJedinica] = useState("");
  // 0 (nista nije selektovano),1, 2, 3...
  const [selectedZastitaOdPozara, setSelectedZastitaOdPozara] = useState(0);
  // 0 (nista nije selektovano),1, 2, 3...
  const [selectedZastitaZivSredine, setSelectedZastitaZivSredine] = useState(0);
  // 0 (nista nije selektovano),1, 2, 3...
  const [selectedPoslovniSaradnici, setSelectedPoslovniSaradnici] = useState(0);
  // 0 (nista nije selektovano),1, 2, 3...
  const [selectedUgovoriOdluke, setSelectedUgovoriOdluke] = useState(0);
  // 0 (nista nije selektovano),1, 2, 3...
  const [selectedSredstvaOprema, setSelectedSredstvaOprema] = useState(0);

  const [dokumentaZaposlenihPretraga, setDokumentaZaposlenihPretraga] =
    useState(emptyPretraga);
  const [sredstvaOpremaPretraga, setSredstvaOpremaPretraga] = useState(null);

  const [isSelectedZaposleni, setIsSelectedZaposleni] = useState(false);

  const [isGlobalnoDodavanjeDokumenta, setIsGlobalnoDodavanjeDokumenta] =
    useState(false);

  // ""-pocetna, "DODAVANJE_POSTOJECI", "AZURIRANJE"
  const [folderDokumentCurrentState, setFolderDokumentCurrentState] =
    useState("");

  // "REVERS", "RAZDUZENJE", "MAGACIN", "OTPIS"
  const [lzoVrstaDokumenta, setLZOVrstaDokumenta] = useState("");

  // id radnog mesta za koje se dodaje dokument (i prikazuju dokumenta)
  const [sisRadnihMestaDokumentaId, setSisRadnihMestaDokumentaId] =
    useState("");

  // podaci koji se azuriraju
  const [editSredstvoData, setEditSredstvoData] = useState(null);
  const [editZaposlenData, setEditZaposlenData] = useState(null);

  const [masineUredjaji, setMasineUredjaji] = useState([]);

  const [locations, setLocations] = useState();
  const [categories, setCategories] = useState(cats);
  const [users, setUsers] = useState();
  const [items, setItems] = useState(i);

  const [selectedDocumentUrl, setSelectedDocumentUrl] = useState(null);

  // const values = {};

  const [selectedCompany, setSelectedCompany] = useState(null);
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [selectedMainEntity, setSelectedMainEntity] = useState(null);

  const [masineUredjajiStatus, setMasineUredjajiStatus] = useState("AKTIVNA");

  const [isShowAccounts, setIsShowAccounts] = useState(false);
  const [lzoScrollToId, setLzoScrollToId] = useState(null);

  const [isZahtevZaPregledSredstva, setIsZahtevZaPregledSredstva] =
    useState(false);

  useEffect(() => {
    if (selectedNavbarDocument && isShowAccounts && !selectedAccount)
      setIsShowAccounts(false);
  }, [selectedNavbarDocument]);

  useEffect(() => {
    setSelectedMainEntity(selectedAccount || selectedCompany);

    // reset to initial
    setSelectedNavbarDocument("");
    setSelectedEvidencija(0);
    setSelectedProcenaRizika(0);
    setSelectedPoslovnaJedinica("");
    setSelectedZastitaOdPozara(0);
    setSelectedZastitaZivSredine(0);
    setSelectedPoslovniSaradnici(0);
    setSelectedUgovoriOdluke(0);
    setSelectedSredstvaOprema(0);
    setDokumentaZaposlenihPretraga(emptyPretraga);
    setSredstvaOpremaPretraga(null);
    setIsSelectedZaposleni(false);
    setIsGlobalnoDodavanjeDokumenta(false);
    setFolderDokumentCurrentState("");
    setLZOVrstaDokumenta("");
    setSisRadnihMestaDokumentaId("");
    setEditSredstvoData(null);
    setEditZaposlenData(null);
    setMasineUredjaji([]);
    setIsZahtevZaPregledSredstva(false);
  }, [selectedCompany, selectedAccount]);

  useEffect(() => {
    setEditSredstvoData(null);
    setEditZaposlenData(null);
    setIsZahtevZaPregledSredstva(false);
  }, [selectedNavbarDocument]);

  const values = {
    lzoScrollToId, setLzoScrollToId,
    masineUredjajiStatus,
    setMasineUredjajiStatus,
    selectedCompany,
    setSelectedCompany,
    selectedDocumentUrl,
    setSelectedDocumentUrl,
    slideButton,
    setSlideButton,
    galleryUrl,
    adminDocsUrl,
    documentsUrl,
    locations,
    setLocations,
    categories,
    setCategories,
    users,
    setUsers,
    items,
    setItems,
    chooseObjectPreview,
    setChooseObjectPrivew,
    fromEnterCode,
    setFromEnterCode,
    isFromFirstTrustContact,
    setIsFromFirstTrustContact,
    isFromHome,
    setIsFromHome,
    fontStyle,
    setFontStyle,
    fontSize,
    setFontSize,
    boldItalic,
    setBoldItalic,
    letterSize,
    setLetterSize,
    typeButton,
    setTypeButton,
    userReload,
    setUserReload,
    selectedLanguage,
    setSelectedLanguage,
    loggedUser,
    setLoggedUser,
    baseUrl,
    account,
    setAccount,
    apiKey,
    setApiKey,
    location,
    setLocation,
    entryKey,
    setEntryKey,
    currentChat,
    setCurrentChat,
    activeIconsMiddle,
    setActiveIconsMiddle,
    controlEmail,
    setControlEmail,
    openAddLink,
    setOpenAddLink,
    newLinks,
    setNewLinks,
    copy,
    setCopy,
    isAndroid,
    setIsAndroid,
    isIOS,
    setIsIOS,
    colorButton,
    setColorButton,
    activeClass,
    setActiveClass,
    idleClass,
    setIdleClass,
    activeIcons,
    setActiveIcons,
    activeStates,
    setActiveStates,
    activeIconsMiddleAdmin,
    setActiveIconsMiddleAdmin,
    cancelIndex,
    setCancelIndex,
    currentName,
    setCurrentName,
    viewDocument,
    setViewDocument,
    openPicture,
    setOpenPicture,
    currentChatAdmin,
    setCurrentChatAdmin,
    chooseObject,
    setChooseObject,
    selectedSettings,
    setSelectedSettings,
    selectedNavbarDocument,
    setSelectedNavbarDocument,
    isSelectedZaposleni,
    setIsSelectedZaposleni,
    selectedEvidencija,
    setSelectedEvidencija,
    selectedProcenaRizika,
    setSelectedProcenaRizika,
    selectedPoslovnaJedinica,
    setSelectedPoslovnaJedinica,
    selectedZastitaOdPozara,
    setSelectedZastitaOdPozara,
    selectedZastitaZivSredine,
    setSelectedZastitaZivSredine,
    selectedPoslovniSaradnici,
    setSelectedPoslovniSaradnici,
    selectedSredstvaOprema,
    setSelectedSredstvaOprema,
    selectedUgovoriOdluke,
    setSelectedUgovoriOdluke,
    dokumentaZaposlenihPretraga,
    setDokumentaZaposlenihPretraga,
    dictionary,
    sredstvaOpremaPretraga,
    setSredstvaOpremaPretraga,
    isGlobalnoDodavanjeDokumenta,
    setIsGlobalnoDodavanjeDokumenta,
    isLZOClicked,
    setIsLZOClicked,
    folderDokumentCurrentState,
    setFolderDokumentCurrentState,
    lzoVrstaDokumenta,
    setLZOVrstaDokumenta,
    sisRadnihMestaDokumentaId,
    setSisRadnihMestaDokumentaId,
    editSredstvoData,
    setEditSredstvoData,
    editZaposlenData,
    setEditZaposlenData,
    masineUredjaji,
    setMasineUredjaji,
    selectedAccount,
    setSelectedAccount,
    selectedMainEntity,
    setSelectedMainEntity,
    isShowAccounts,
    setIsShowAccounts,
    isZahtevZaPregledSredstva,
    setIsZahtevZaPregledSredstva
  };

  useEffect(() => {
    let newActiveStates = [];
    activeStates.forEach((state) => {
      if (activeIcons.find((icon) => icon.name === state.name) !== undefined)
        newActiveStates.push(state);
    });
    setActiveStates(newActiveStates);
    /*let messages = activeIcons.find((icon) => icon.name === "MESSAGES");
    if (messages === undefined) setCurrentChat(null);*/
  }, [activeIcons]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.post(
          `${baseUrl}/admin_panel/user_themes/readUserTheme.php`,
          {
            user_id: loggedUser.id,
            api_key: apiKey
          }
        );
        const { data } = response;
        console.log(data);
        if (data.status === 200) {
          setIdleClass(`${data.value}-btn`);
          setActiveClass(`${data.value}-btn-active`);
        } else {
          setIdleClass("dos-btn");
          setActiveClass("dos-btn-active");
        }
      } catch (error) {}
    };
    fetchData();
  }, []);

  return <AppContext.Provider value={values}>{children}</AppContext.Provider>;
};

export const useGlobalContext = () => {
  return useContext(AppContext);
};

export { AppContext, AppProvider };
